import { useMemo } from "react";
import {
  IconChevronLeft,
  IconChevronRight,
  IconDots,
} from "@tabler/icons-react";

import styles from "./styles.module.css";

import { FormattedMessage } from "react-intl";

const commonIconProps = {
  role: "button",
  size: 20,
};

const PaginationComponent = ({
  totalPages,
  currentPage,
  onChangePage,
  counter,
  isLoading,
}: {
  totalPages: number;
  currentPage: number;
  onChangePage: (page: number) => void;
  counter?: number;
  isLoading?: boolean;
}) => {
  const isCurrentFirst = currentPage === 1;
  const isCurrentLast = currentPage === totalPages;

  const paginationButtons = useMemo(() => {
    let isPageNumberOutOfRange = false;

    return [...new Array(totalPages)].map((_, index) => {
      const pageNumber = index + 1;
      const isPageNumberFirst = pageNumber === 1;
      const isPageNumberLast = pageNumber === totalPages;
      const isCurrentPageWithinTwoPageNumbers =
        Math.abs(pageNumber - currentPage) <= 2;

      if (
        isPageNumberFirst ||
        isPageNumberLast ||
        isCurrentPageWithinTwoPageNumbers
      ) {
        isPageNumberOutOfRange = false;
        return (
          <button
            key={pageNumber}
            className={`${styles.btn} ${
              pageNumber === currentPage ? styles.btnActive : ""
            }`}
            onClick={() => onChangePage(pageNumber)}
          >
            {pageNumber}
          </button>
        );
      }

      if (!isPageNumberOutOfRange) {
        isPageNumberOutOfRange = true;
        return (
          <div className="flex align-items-end">
            <IconDots key="dots" size={18} />
          </div>
        );
      }

      return null;
    });
  }, [totalPages, currentPage, onChangePage]);

  return (
    <div className="flex w-100">
      <div
        className={`flex ${styles.flex1} justify-content-start align-items-center color-step-600 fs-2`}
      >
        <FormattedMessage
          id="common.results"
          values={{
            total: counter ? counter : 0,
          }}
        />
      </div>

      {totalPages > 1 && !isLoading && (
        <div
          className={`flex ${styles.flex1} gap-3 align-items-center justify-content-end`}
        >
          <IconChevronLeft
            {...commonIconProps}
            onClick={() => onChangePage(currentPage - 1)}
            className={`${isCurrentFirst ? styles.actionDisable : ""}`}
          />
          <div className="flex gap-2">{paginationButtons}</div>
          <IconChevronRight
            {...commonIconProps}
            onClick={() => onChangePage(currentPage + 1)}
            className={`${isCurrentLast ? styles.actionDisable : ""}`}
          />
        </div>
      )}
    </div>
  );
};

export default PaginationComponent;
